import type { SidebarUser } from '@elva/ui';
import { useAuthStore } from '@elva/platform';

function initialsFromName(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  const first = parts[0];
  if (!first) return '?';
  if (parts.length === 1) return first.slice(0, 2).toUpperCase();
  const last = parts[parts.length - 1];
  return `${first[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase();
}

/**
 * The signed-in account, shaped for the top-right `UserMenu` (spec 41). One source
 * for every top bar — the shared `TopBar` and the Calendar/Bird Eye headers — so
 * the account looks and behaves the same across the app.
 */
export function useAccountUser(): SidebarUser {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  const displayName = user?.name.trim() ?? user?.email.split('@')[0] ?? 'Account';
  const roleLabel =
    user?.role && typeof user.role === 'object' && user.role.name ? user.role.name : 'Front desk';

  return {
    name: displayName,
    role: roleLabel,
    initials: initialsFromName(displayName),
    onLogout: () => {
      void logout().catch(() => undefined);
    },
  };
}
